import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState, useCallback } from "react";
import PageTableHeader from "../../../components/pageTableHeader/pageTableHeader";
import SalaryCard from "./components/SalaryCard";
import Loading from "../../../components/skeleton/loading";
import { getUserDetailProfile } from "../../../../services/workspace/user.service";
import toast from "react-hot-toast";

const items = [
  { label: "Staff Directory", path: "/hr/staff-directory" },
  { label: "Assign Salary", path: "" },
];

const AssignSalary = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [employeeData, setEmployeeData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchUser = useCallback(async () => {
    if (!id) return;
    setLoading(true);
    try {
      const response = await getUserDetailProfile(id, {
        with: "department,designation",
        additional_info: true,
      });
      const user = response?.user || response?.data?.user || {};
      setEmployeeData(user);
    } catch (e) {
      toast.error("Failed to fetch staff details!");
      setEmployeeData(null);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  if (loading && !employeeData) {
    return (
      <div className="flex flex-col gap-2">
        <PageTableHeader breadcrumbs={items} />
        <Loading height="min-h-[280px]" />
      </div>
    );
  }

  if (!id) {
    navigate("/hr/staff-directory");
    return null;
  }

  return (
    <div className="flex flex-col gap-2">
      <PageTableHeader
        breadcrumbs={items}
        add={false}
        isSearch={false}
      />
      <div className="mt-4">
        <SalaryCard
          employeeId={id}
          employeeData={employeeData}
          onUpdate={async () => {
            await fetchUser();
          }}
        />
      </div>
    </div>
  );
};

export default AssignSalary;
